import type {Auth, Exemplar} from 'src/typings';
import {anyMatches, byId} from 'shared/utils/array-utils';
import type {ExemplarFilterFunction} from './types';

export default class ExemplarFilter {

    constructor(private showableExemplarStatuses: number[]) {}

    forUser(auth?: Auth): ExemplarFilterFunction {
        return (exemplar: Exemplar) => {
            if (auth) {
                if (auth.role.includes('ROLE_ADMIN')) {
                    return true;
                }

                if (anyMatches(auth.editableDepartments, byId(exemplar.department.id))) {
                    return true;
                }
            }

            return this.showableExemplarStatuses.includes(exemplar.status.id);
        };
    }

    public get anonymous(): ExemplarFilterFunction {
        return this.forUser();
    }
}